import SimilarCourse from '@jobseeker/feature-course/components/SimilarCourse';
import {AppState} from '@jobseeker/common-core/types';
import {CrossIcon} from '@jobseeker/lotus/assets/icons';
import {Box, Dialog} from '@mui/material';
import {Image} from '@jobseeker/lotus/components/Image';
import {Dispatch, SetStateAction} from 'react';
import {useSelector} from 'react-redux';

type EnquirySuccessPopupProps = {
  closePopup: () => void;
  enquiredCourseId: number;
  enquiryId: number;
  setdialogOpen?: Dispatch<SetStateAction<boolean>>;
};

const EnquirySuccessPopup = (props: EnquirySuccessPopupProps) => {
  const {closePopup, enquiredCourseId, enquiryId, setdialogOpen} = props;

  const {
    userId,
    authInfo: {token},
  } = useSelector((state: AppState) => state.auth);

  const {experienceYear, locations} = useSelector(
    (state: AppState) => state.user.profile
  );

  return (
    <Dialog
      open
      onClose={closePopup}
      fullWidth
      sx={{
        '.MuiDialog-paper': {
          maxWidth: 900,
          minHeight: 120,
        },
      }}
    >
      <Box display={'flex'} justifyContent={'flex-end'}>
        <Box
          onClick={closePopup}
          sx={{
            cursor: 'pointer',
            position: 'relative',
            width: '50px',
            height: '50px',
            backgroundColor: '#f2f5fa',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: 1,
            '&:hover': {
              backgroundColor: 'white',
              boxShadow: '0 6px 14px 0 rgba(0, 0, 0, 0.09)',
            },
          }}
        >
          <Image src={CrossIcon} alt="cross-icon" height={12} width={12} />
        </Box>
      </Box>
      <SimilarCourse
        enquiredCourseId={enquiredCourseId}
        userId={userId}
        token={token ?? ''}
        enquiryId={enquiryId}
        userExp={experienceYear}
        userLocation={locations?.current.id}
        setdialogOpen={setdialogOpen}
      />
    </Dialog>
  );
};

export default EnquirySuccessPopup;
